module.exports = __webpack_public_path__ + "static/00032.771b9dcd.jpg";